import { render, staticRenderFns } from "./coupon-data.vue?vue&type=template&id=041dd6ca&scoped=true&"
import script from "./coupon-data.vue?vue&type=script&lang=js&"
export * from "./coupon-data.vue?vue&type=script&lang=js&"
import style0 from "./coupon-data.vue?vue&type=style&index=0&id=041dd6ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041dd6ca",
  null
  
)

export default component.exports